import {
    ReactElement,
    useRef,
} from 'react';

import {
    MantineDataTable,
    SimpleTableBatchAction,
} from '@flexinet/ui-components';
import {useAliasesSelection} from '../hooks/useAliasesSelection';
import {useAliases} from "../hooks/useAliases.ts";
import {useAliasesTableColumns} from "../hooks/useAliasesTableColumns.tsx";
import {useAliasesSearch} from "../hooks/useAliasesSearch.ts";
import {useAliasesPaging} from "../hooks/useAliasesPaging.ts";
import {useAuth} from "../../../hooks/useAuth.ts";
import {useVerifiedPermissions} from "../../../hooks/useVerifiedPermissions.ts";
import {Stack} from '@mantine/core';
import {Alias} from "../types.ts";
import {AliasFilters} from '../buttons/FilterRecordsButton.tsx';
import {DataTableColumn} from "mantine-datatable";
import {DataTableTokenPagination} from '../../../components/DataTableTokenPagination';
import {addToSelection} from '../reducers';
import {useAppDispatch} from '../../../hooks/useTypedReactRedux';


export const RecordsTable = ({
                                 filters,
                                 extraTools,
                                 settings,
                             }: {
    filters?: AliasFilters,
    extraTools?: ReactElement[],
    settings?: { label: string, onClick: () => void }[]
}) => {

    const dispatch = useAppDispatch();

    const {
        user
    } = useAuth();


    if (!user) {
        throw new Error('user is required parameter')
    }

    const {allowedActions} = useVerifiedPermissions()


    const {
        visibleItems,
        visibleCount,
        nextToken,
        fetchRecords,
        isFetchingNextPage,
    } = useAliases(filters);

    const scrollViewportRef = useRef<HTMLDivElement>(null);

    const {
        columns,
    } = useAliasesTableColumns();

    const {
        handleFilterByKeyword,
    } = useAliasesSearch();

    const {
        limit,
        handleItemsPerPageChange,
    } = useAliasesPaging();


    const {
        selection,
        handleClearSelection,
    } = useAliasesSelection();


    let selectedRecords = [] as Alias[];
    if (allowedActions.includes('DeleteAlias')) {
        selectedRecords = Object.keys(selection)
                                .map(key => selection[key])
    }


    return (
        <Stack gap={'lg'}>
            <SimpleTableBatchAction
                limit={limit}
                handleItemsPerPageChange={handleItemsPerPageChange}
                settings={settings}
                handleFilterByKeyword={handleFilterByKeyword}
                extraTools={extraTools}
            />

            <MantineDataTable
                columns={columns as DataTableColumn[]}
                records={visibleItems}
                selectedRecords={selectedRecords}
                onSelectedRecordsChange={(items) => {
                    handleClearSelection();
                    items.forEach(item => {
                        dispatch(addToSelection(item as unknown as Alias));
                    })
                }}
                fetching={false}
                onScrollToBottom={() => fetchRecords()}
                scrollViewportRef={scrollViewportRef}
                withTableBorder={true}
            />

            <DataTableTokenPagination
                totalCount={visibleCount.toString()}
                nextToken={nextToken}
                handleLoadMore={fetchRecords}
                loading={isFetchingNextPage}
            />

        </Stack>
    );
};